module.exports = __webpack_public_path__ + "img/AnimatedLogo.5035a490.gif";